import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@4.5.2_ddfa93a9b184680e8cef752accbdf0d4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@4.5.2_ddfa93a9b184680e8cef752accbdf0d4/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "require-distribution": () => import("/opt/build/repo/app/middleware/require-distribution.ts"),
  "require-vendor": () => import("/opt/build/repo/app/middleware/require-vendor.ts")
}